import { useParams } from 'react-router-dom';

export function useSubdomain() {
  const { orgId } = useParams<{ orgId: string }>();

  const isAppRoot = orgId === 'app';

  return {
    subdomain: orgId,
    orgId,
    isAppRoot,
    isSubdomainRoute: !isAppRoot,
  };
}
